import * as React from 'react';
import { styled } from '@mui/styles';
import Button from '@mui/material/Button';
import FiberNewRoundedIcon from '@mui/icons-material/FiberNewRounded';
import LocalPrintshopRoundedIcon from '@mui/icons-material/LocalPrintshopRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import ManageSearchRoundedIcon from '@mui/icons-material/ManageSearchRounded';
import { makeStyles } from '@mui/styles';
import BasicMenu from '../CustomMenu/Basicmenu';
import AppBar from '@mui/material/AppBar';

import Toolbar from '@mui/material/Toolbar';
import PropTypes from 'prop-types';
import GradingRoundedIcon from '@mui/icons-material/GradingRounded';
import { Hidden } from '@material-ui/core';
import MenuIcon from '@mui/icons-material/Menu';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import topbarStype from '../../assets/jss/psstyle/component/topbarStype';


const useStyles = makeStyles(topbarStype);

export default function Topbar(props) {

    const classes = useStyles();
    const { listmenu, title } = props
    const [disabledbutton, setdisabledbutton] = React.useState(false)

    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    })
    const [anchor, setanchor] = React.useState("top")
    const handleClick = (e) => {
        //console.log("handleClick", e);
        if (e == "new") {
            setdisabledbutton(false)
        } else if (e == "search") {
            setdisabledbutton(true)
        }
        props.onClick(e)
    }

    React.useEffect(() => {

        console.log("listmenu", listmenu)
        return () => {

        }
    }, [listmenu])

    const list = (
        <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
            <Typography sx={topbarStype.Typographytop}
            >
                <MenuItem sx={topbarStype.MenuItemtop} onClick={() => handleClick("save")} disabled={disabledbutton}>
                    <SaveRoundedIcon /> บันทึก
                </MenuItem>
            </Typography>
            <Typography sx={topbarStype.Typographytop}>
                <MenuItem sx={topbarStype.MenuItemtop} onClick={() => handleClick("new")}>
                    <FiberNewRoundedIcon /> ใหม่
                </MenuItem>
                {/* <Button variant="inherit" sx={{ border: "none" }} color="inherit" startIcon={<FiberNewRoundedIcon />}
                    onClick={() => handleClick("new")}
                // className={classes.Buttons}
                >
                    ใหม่
                </Button> */}
            </Typography>
            <Typography sx={topbarStype.Typographytop}
            >
                <MenuItem sx={topbarStype.MenuItemtop} onClick={() => handleClick('search')}>
                    <SearchRoundedIcon /> ค้นหา
                </MenuItem>
            </Typography>
            {/* <Typography sx={topbarStype.Typographytop} >
                <MenuItem sx={topbarStype.MenuItemtop} onClick={() => handleClick('print')}>
                    <LocalPrintshopRoundedIcon /> พิมพ์
                </MenuItem>
            </Typography> */}
            <Typography component="div" sx={topbarStype.Typographytop}
            >
                <BasicMenu
                    listmenu={listmenu}
                    // variant="inherit" sx={{ border: "none" }} color="inherit"
                    startIcon={<GradingRoundedIcon />}
                    onClick={e => handleClick(e)}
                />
            </Typography>
        </Box>
    )
    const listsm = (anchor) => (
        <Box
            sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
            className={classes.txt}
        >
            <List className={classes.txt}>
                <ListItem key={"save"} className={classes.txt} >
                    <ListItemIcon>
                        <SaveRoundedIcon />
                    </ListItemIcon>
                    <ListItemText primary={
                        <Typography color="textSecondary" variant="body1" className={classes.txt} onClick={() => handleClick("save")} >
                            {"บันทึก"}
                        </Typography>
                    } />
                </ListItem>
                <ListItem key={"new"}>
                    <ListItemIcon>
                        <FiberNewRoundedIcon />
                    </ListItemIcon>
                    <ListItemText primary={
                        <Typography color="textSecondary" variant="body1" onClick={() => handleClick("new")}>
                            {"ใหม่"}
                        </Typography>} />
                </ListItem>
                <ListItem key={"search"}>
                    <ListItemIcon>
                        <SearchRoundedIcon />
                    </ListItemIcon>
                    <ListItemText primary={
                        <Typography color="textSecondary" variant="body1" className={classes.txt} onClick={() => handleClick('search')}>
                            {"ค้นหา"}
                        </Typography>
                    } />
                </ListItem>
                {/* <ListItem key={"print"} >
                    <ListItemIcon>
                        <LocalPrintshopRoundedIcon />
                    </ListItemIcon>
                    <ListItemText primary={<Typography color="textSecondary" variant="body1" className={classes.txt} onClick={() => handleClick("print")}
                    >  {"พิมพ์"}
                    </Typography>} />
                </ListItem> */}
            </List>
            <Divider />
            <ListItem key={"keys"}>
                <ListItemIcon>
                    <GradingRoundedIcon />
                </ListItemIcon>
                <ListItemText primary={
                    <Typography color="textSecondary" variant="body1" className={classes.txt}>
                        {"Key"}
                    </Typography>}
                />
            </ListItem>
            <List>
                {listmenu.map((text, index) => (
                    <ListItem key={index + "Key"}  >
                        <ListItemIcon>
                        </ListItemIcon>
                        <ListItemText primary={
                            <Typography key={index + "Key"} color="textSecondary" variant="body1" className={classes.txt} onClick={e => handleClick(text[1])}>
                                {text[0]}
                            </Typography>
                        } />
                    </ListItem>
                ))}
            </List>
        </Box>
    );
    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };
    return (
        <div>
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="static" enableColorOnDark color="inherit" id='topbar'>
                    <Toolbar variant="dense" id='topbarToolbar'>
                        <Box sx={{ flexGrow: 1 }}>
                            <Hidden mdUp>
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    onClick={toggleDrawer(anchor, true)}
                                >
                                    <MenuIcon />
                                </IconButton>
                            </Hidden>
                            <Hidden smDown>
                                {list}
                            </Hidden>
                        </Box>
                        <Box sx={{ justifyContent: 'flex-end' }}>
                            <Typography sx={topbarStype.txt}>{title}</Typography>
                        </Box>
                    </Toolbar>
                </AppBar>
            </Box>

            <React.Fragment key={anchor}>
                <SwipeableDrawer
                    anchor={anchor}
                    open={state[anchor]}
                    onClose={toggleDrawer(anchor, false)}
                    onOpen={toggleDrawer(anchor, true)}
                >
                    {listsm(anchor)}
                </SwipeableDrawer>
            </React.Fragment>
        </div>
    )
}
Topbar.propTypes = {
    listmenu: PropTypes.array,
    title: PropTypes.string
}

Topbar.defaultProps = {
    listmenu: [],
    title: ""

}